import { makeStyles } from '@material-ui/core/styles';

import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  tag: {
    alignItems: 'center',
    backgroundColor: theme.colorPalette.beige_50,
    borderRadius: theme.spacing(8),
    fontSize: 12,
    fontWeight: 600,
    height: 24,
    padding: theme.spacing(1, 2),
    width: 'fit-content',
    ...reskinStyles(theme, theme.labelStyles.outlined)
  }
});

export default makeStyles(styles);
